import { css } from 'styled-components';

export const inputContainer = css`
  display: grid;
  padding: 4px;
  width: 100%;
  grid-template-columns: auto auto;
  column-gap: 8px;
`;
